<template>
  <div class="header-munu-tar-modular">
    <div class="header-top-tar-modualr" v-if="isShowTar">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#000000"
        text-color="#fff"
        active-text-color="#fff"
      >
        <el-menu-item
          :index="item.index"
          v-for="(item, index) in menuTarList"
          @click="toPath(item.jumpurl,index)"
          :key="index"
        >
          <el-dropdown
            v-if="index == 1"
            @click="toPath(item.jumpurl)"
            @command="searchProductByType"
            style="width: 108px;"
          >
            <el-button @click="toPath(item.jumpurl)">
              {{ currLanguage == 3 ? item.eng_title : item.title }}
            </el-button>
            <el-dropdown-menu slot="dropdown" class="el-dropdown-modular">
              <el-dropdown-item
                v-for="(item, index) in bannerTarList"
                :key="index"
                :command="{ index: index, id: item.id }"
                v-if="item.id != 0"
                >{{
                  currLanguage == 3 ? item.eng_name : item.name
                }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <div v-else>
            {{ currLanguage == 3 ? item.eng_title : item.title }}
          </div>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "headerMenu",
  data() {
    return {
      equipmentType: null,
      searchTarLength: null,
      isShowTar: true,
      activeIndex: "0",
      menuTarList: [],
      currLanguage: localStorage.getItem("curLanguageType"),
      // { title: "首页", index: "1", path: "/" },
      // { title: "产品", index: "2", path: "/productShow" },
      // { title: "回流焊系列", index: "3", path: "/" },
      // { title: "贴片机系列", index: "4", path: "/" },
      // { title: "拆焊台系列", index: "5", path: "/" },
      // { title: "关于我们", index: "6", path: "/aboutUs" },
      // { title: "博客", index: "7", path: "/blogManagement" },
      // { title: "论坛", index: "8", path: "/forumManagement" },
      bannerTarList: [],
    };
  },
  methods: {
    handleSelect(val) {
      // console.log('val', val.toString());
      // this.activeIndex = val.toString()
    },
    /**
     * 跳转页面
     * @param {*} jumpurl 
     * @param {*} index 
     */
    toPath(jumpurl,index) {
      // console.log("jumpurl------", jumpurl);
      // console.log('index',index);
      // console.log('menuActiveIndex',this.activeIndex);

      // localStorage.setItem('menuActiveIndex',index);
      
       let path=jumpurl;
      window.location.href=path

    },

    /**
     * 跳转对应页面
     * @param {*} index
     */
    toNextBymae(jumpurl) {
      console.log(index);
      switch (index) {
        // 首页
        case "0":
          this.$router.push(
            {
              path: "/",
            },
            () => {}
          );
          break;
        //产品
        case "1":
          this.$router.push(
            {
              path: "/productShow",
            },
            () => {}
          );
          break;
        // "回流焊系列"
        case "2":
          this.$router.push(
            {
              path: "/productShowByType",
              query: { type_id: "1" },
            },
            () => {}
          );
          localStorage.setItem("menuActiveIndex", 2);
          this.$parent.$parent.reload();

          // this.$parent.$parent.reload();
          break;
        //"贴片机系列"
        case "3":
          this.$router.push(
            {
              path: "/productShowByType",
              query: { type_id: "2" },
            },
            () => {}
          );

          localStorage.setItem("menuActiveIndex", 3);
          this.$parent.$parent.reload();
          // this.$parent.$parent.reload();
          break;
        // case "贴片机":
        //   this.$router.push(
        //     {
        //       path: "/productShowByType",
        //       query: { type_id: "2" },
        //     },
        //     () => {}
        //   );
        //   localStorage.setItem("menuActiveIndex", 2);
        //   this.$parent.$parent.reload();
        //   break;
        //"拆焊台系列"
        case "4":
          this.$router.push({
            path: "/productShowByType",
            query: { type_id: "5" },
          });
          localStorage.setItem("menuActiveIndex", 4);
          this.$parent.$parent.reload();
          break;
        //"关于我们"
        case "5":
          this.$router.push(
            {
              path: "/aboutUs",
            },
            () => {}
          );
          break;
        // "博客"
        case "6":
          this.$router.push(
            {
              path: "/blogManagement",
            },
            () => {}
          );
          break;
        //"论坛"
        case "7":
          this.$router.push(
            {
              path: "/forumManagement",
            },
            () => {}
          );
          break;

        default:
          break;
      }
    },
    /**
     * 根据类型获取商品
     * @param {*} index
     * @param {*} id
     * index, levId
     */
    searchProductByType(command) {
      console.log("searchProductByType", command);
      let levId = command.id;
      let index = command.index;
      let that = this;
      this.$parent.$refs.headerMenuModular.activeIndex = 1;
      localStorage.setItem("menuActiveIndex", 1);
      // 产品类型ID
      this.$router.push({
        path: "/productShow",
        query: {
          currProductTypeId: levId,
          index: index,
          levId: levId,
          pageStaus: 1,
        },
      });
      this.$parent.$parent.reload();
    },
    /**
     * 购物车
     */
    toshoppingcart() {
      this.$router.push({
        path: "/shoppingcart",
        // query: { name: '', age: '' }
      });
    },
    /**
     * 判断是手机还是PC 更改展示的数据长短
     */
    judgePcOrPhone() {
      let that = this;
      that.equipmentType = localStorage.getItem("equipmentType");
      if (that.equipmentType == 1) {
        // 1-手机端
        that.searchTarLength = 5;
      } else {
        that.getMenuList();
        // that.getCategoryList();
        // 0-pc端
        // that.searchTarLength = 9;
        if (that.pageWidth >= 1600) {
          that.searchTarLength = 8;
        } else if (1200 <= that.pageWidth < 1600) {
          that.searchTarLength = 6;
        } else if (500 < that.pageWidth < 1200) {
          that.searchTarLength = 7;
        } else {
          that.searchTarLength = 4;
        }
      }
    },
    /**
     * 获取导航栏
     */
    getMenuList() {
      let that = this;
      that.getCategoryList();
      this.$http.getMenuList(
        null,
        (res) => {
          if (res.ret == 1) {
            // 清空
            that.menuTarList = [];
            res.data.forEach((v, i) => {
              that.menuTarList.push({
                title: v.name,
                index: i.toString(),
                eng_title: v.eng_name,
                jumpurl: v.jumpurl,
              });
            });
            console.log(menuTarList);
            // api数据翻译
            that.translateApiData(res.data, "name", 0);
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title, flag) {
      let that = this;
      let newTextArr = [];
      console.log("data", data);
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      // console.log("newTextArr", newTextArr);
      that.languageTranslateByArr(newTextArr, flag);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, flag) {
      let that = this;
      let newText = "";
      console.log("languageTranslateByArr", arr);
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, flag);
        },
        (res) => {
          newText = "";
        }
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, flag) {
      let that = this;
      console.log("data", data);
      if (flag == 0) {
        data.forEach((v, i) => {
          that.menuTarList[i].title = v.translation;
        });
        console.log("that.menuTarList", that.menuTarList);
      } else if (flag == 1) {
        data.forEach((v, i) => {
          that.bannerTarList[i].name = v.translation;
        });
      }
    },

    /**
     * 商品分类
     */
    getCategoryList() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 1000,
      };
      that.bannerTarList = []; //清空
      this.$http.getCategoryList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.bannerTarList = res.data;
            // api数据翻译
            that.translateApiData(res.data, "name", 1);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
  },
  mounted() {
    let that = this;
    that.judgePcOrPhone();
    // 导航栏
    // that.getMenuList();

    // that.getCategoryList();
    // console.log('activeIndex', that.activeIndex);
  },
};
</script>

<style lang="scss">
.header-munu-tar-modular {
  width: 100%;
  .header-top-tar-modualr {
    // width: 1200px;
    .el-menu {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom-width: 0px;
      .el-menu-item {
        // font-size: 20px;
        // width: 10%;
        text-align: center;
      }
      .el-button {
        border: none;
        background-color: rgb(0, 0, 0);
        .el-icon-arrow-down {
          display: none;
        }
      }

    }
    .el-menu>.el-menu-item:nth-child(2){
      padding: 0;
    }
    .el-menu > .is-active {
      border-bottom-color: #ec0000 !important;
    }

    .el-menu--horizontal > .el-menu-item {
      float: unset !important;
    }
    .el-button-group > .el-button:first-child {
      background-color: black;
      border: 1px solid black;
    }

    .el-button-group > .el-button:last-child {
      background-color: black;
      border: 1px solid black;
    }
    .el-menu-item * {
      color: white;
    }
    .el-dropdown .el-button {
      margin-bottom: 10px;
    }
  }
}

@media screen and (max-width: 500px) {
  .header-munu-tar-modular {
    .header-top-tar-modualr {
      display: none;

      .el-menu {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        overflow: hidden;
      }
    }
  }
}
.el-dropdown-modular {
  // background-color: red;
  padding-bottom: 25px;
  // position: relative;
  // left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/headerMenu.vue